import { useCallback, useState } from 'react'

import { observeIntersection, unobserveIntersection } from '@/utils/observerUtil'

export type InViewStatus = 'inView' | 'nearView' | 'outside'

type Props = {
  assumeInView?: boolean
  forceLoad?: boolean
}

export const useInView = ({ assumeInView = false, forceLoad }: Props = {}) => {
  const [inView, setInView] = useState(assumeInView)
  const [nearView, setNearView] = useState(assumeInView)

  const ref = useCallback(
    (node: HTMLElement | null) => {
      if (!node || forceLoad) return

      observeIntersection('inView', node, (entry) => {
        setInView(entry.isIntersecting)
      })

      observeIntersection('nearView', node, (entry) => {
        setNearView(entry.isIntersecting)
      })

      return () => {
        unobserveIntersection('inView', node)
        unobserveIntersection('nearView', node)
      }
    },
    [forceLoad],
  )

  const inViewStatus: InViewStatus = forceLoad || inView ? 'inView' : nearView ? 'nearView' : 'outside'

  return { inViewStatus, ref }
}
